var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{style:({height:this.h, width:this.w})},[_c('div',{staticClass:"google-map",attrs:{"id":_vm.name}})])
}
var staticRenderFns = []

export { render, staticRenderFns }